import { useEffect } from "react";

let counter = 0;

/**
 * JsonLd - injects a <script type="application/ld+json"> tag into <head>
 * for the lifetime of the component, and removes it on unmount.
 * Pass one object or an array of schema objects via `data`.
 */
const JsonLd = ({ data }) => {
  useEffect(() => {
    if (!data) return;
    const id = `jsonld-${counter++}`;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data)]);

  return null;
};

export default JsonLd;
